import { render, staticRenderFns } from "./selectProductDrawer.vue?vue&type=template&id=640b72f9&scoped=true"
import script from "./selectProductDrawer.vue?vue&type=script&lang=js"
export * from "./selectProductDrawer.vue?vue&type=script&lang=js"
import style0 from "./selectProductDrawer.vue?vue&type=style&index=0&id=640b72f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b72f9",
  null
  
)

export default component.exports